export type ContactTranslation = {
  backToStart: string;
  copySuccess: string;
  jeronimoCard: { bulletPoints: string[]; subtitle: string; title: string };
  knowmeCard: { bulletPoints: string[]; subtitle: string; title: string };
  title: string;
};

export const contactTranslation: ContactTranslation = {
  backToStart: 'Back to Start',
  copySuccess: 'Email copied to clipboard',
  jeronimoCard: {
    bulletPoints: [
      'MDR process questions and guidance',
      'Succession planning module support',
      'Performance evaluation methodology',
      'Training program content and structure',
    ],
    subtitle: 'Business process and content questions:',
    title: 'Support from Learning and Development Department',
  },
  knowmeCard: {
    bulletPoints: [
      'App crashes, bugs, or glitches',
      'Login and authentication problems',
      'Data not loading or syncing correctly',
      'Platform performance issues',
      'User interface not working as expected',
      'Export/import functionality errors',
    ],
    subtitle: 'Report technical issues with the platform:',
    title: 'jAIn Technical Support',
  },
  title: 'Contact',
};
